import React from "react"
import { Grid, Divider } from "@material-ui/core"
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
} from "App/Component/ui"
import { TYPE_INSTANCE4 } from "App/constants"
import { useSelectOption } from "App/hooks"
import { RESET_STATE_FORM_FILTER } from "./helpers"
import { LIST_URL_WAREHOUSE } from "utils/warehouse"

export default function FormFilterDaftarAdjusmentStock({
  formFilter,
  setFormFilter,
  setNewData,
}) {
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    await setNewData()
  }

  const gudangUtama = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterGudangPBF.getGudang,
    TYPE_INSTANCE4,
    "gudangId",
    "name",
    "data",
  )

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={4}>
            <InputTextMaster
              name="id"
              label="ID ADJUSMENT"
              id="id"
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder="ID Adjusment"
            />
          </Grid>
          <Grid item sm={4}>
            <InputOptionMaster
              name="gudang_id"
              label="GUDANG UTAMA MEDIS"
              id="gudang_id"
              withSearch={true}
              data={gudangUtama}
              value={formFilter.gudang_id}
              labelValue={formFilter.gudang}
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  gudang_id: e?.value,
                  gudang: e?.label,
                })
              }
            />
          </Grid>
          <Grid item sm={4}>
            <InputOptionMaster
              name="status_id"
              label="STATUS"
              id="status_id"
              withSearch={true}
              data={[
                {
                  label: "DRAFT",
                  value: false,
                },
                {
                  label: "PROCESS",
                  value: true,
                },
              ]}
              value={formFilter.status}
              labelValue={formFilter.statusName}
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  status: e?.value,
                  statusName: e?.label,
                })
              }
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            type={"submit"}
            size={"md"}
          />
        </Grid>
        <br />
      </form>
      <Divider />
    </>
  )
}
